module.exports = __webpack_public_path__ + "static/media/laliga.9c5d32f4.png";